export enum QUOTE_KIND_ENUM {
  Puro = 'Puro',
  Financiero = 'Financiero'
}

export enum QUOTE_KIND_COLOR_ENUM {
  Puro = 'primary',
  Financiero = 'primary'
}

export enum QUOTE_STATUS_ENUM {
  'En prospección' = 'En prospección',
  'Aceptada' = 'Aceptada',
  'Cancelada' = 'Cancelada'
}

export enum QUOTE_STATUS_COLOR_ENUM {
  'En prospección' = 'warning',
  'Aceptada' = 'success',
  'Cancelada' = 'danger'
}
